<template>
  <LinkWrapper :href="event.eventUrl" target="_blank" @click="handleClick">
    <DynamicText
      :id="teamNameFont"
      tag="p"
      styleGroup="Event Name"
      :get="fixtureNameStyle.get"
      :set="fixtureNameStyle.set"
      class="team-one"
      >{{ event?.competitors[team].name.short }}</DynamicText
    >
  </LinkWrapper>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { injectBetData } from "@fresh8/ad-data-composition/src/betData";
import { Brand } from "@fresh8/types/src";

import DynamicText from "./DynamicText.vue";
import LinkWrapper from "./LinkWrapper.vue";

import { injectCardNumber, useAnalytics } from "../hooks/useAnalytics";

export default defineComponent({
  name: "Competitors",
  components: {
    DynamicText,
    LinkWrapper
  },
  props: {
    eventId: {
      type: String,
      required: true
    },
    team: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const { events } = injectBetData();
    const { marketBranding } = injectBrand();
    const cardNumber = injectCardNumber();
    const { handleClick } = useAnalytics(
      { ...props, cardNumber },
      "Event Name"
    );

    return {
      handleClick,
      fixtureNameStyle: {
        get: (brand: Brand | undefined) =>
          brand && brand.adTemplate.market.teamNameFont,
        set: (brand: Brand | undefined, value: string) =>
          brand && (brand.adTemplate.market.teamNameFont = value)
      },
      event: computed(() => events.value?.[props.eventId] || null),
      teamNameFont: computed(() => marketBranding.value?.teamNameFont || "")
    };
  }
});
</script>

<style></style>
